export const ABILITY_POINTS_DICT = {
    '1-1': '1.1 檢視文本中的資訊',
    '1-2': '1.2 擷取和使用資料',
    '2-1': "2.1 闡釋文章",
    '2-2': "2.2 整合並作出推論",
    '3-1': '3.1 評估質素和可信性',
    '3-2': "3.2 反思及評價文章的形式或內容",
    '3-3': "3.3 檢測並處理衝突",
}

export const ABILITY_POINTS_DICT_2 = {
    '1.1 檢視文本中的資訊':'1-1',
    '1.2 擷取和使用資料':'1-2',
    '2.1 闡釋文章':'2-1',
    '2.2 整合並作出推論':'2-2',
    '3.1 評估質素和可信性':'3-1',
    '3.2 反思及評價文章的形式或內容':'3-2',
    '3.3 檢測並處理衝突':'3-3',
}

export const ABILITY_POINTS_LIST = [
    '1-1',
    '1-2',
    '2-1',
    '2-2',
    '3-1',
    '3-2',
    '3-3',
]